/**
* DevExpress Dashboard (_format-condition-expression.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { replaceExpressionParametersPrefix } from '../../../internal/_expression-utils';
import { formatConditionStyleBaseSerializationsInfo } from './_format-condition-style-base';
export let formatConditionExpression = { propertyName: 'expression', modelName: '@Expression', from: (expressionStr) => {
        return replaceExpressionParametersPrefix(expressionStr);
    } };
export let formatConditionFilter = { propertyName: 'expression' };
export let formatConditionExpressionSerializationsInfo = formatConditionStyleBaseSerializationsInfo.concat([formatConditionExpression]);
